<script lang="ts">
	import type { ComponentSectionsBottomActions } from '$lib/graphql/strapiApi';
	import { buttonVariants } from '$lib/components/ui/button';
	import { cn } from '$lib/utils.js';

	let { content }: { content: ComponentSectionsBottomActions } = $props();
	let buttons = $derived(content.buttons?.filter((x) => x !== null) ?? []);
</script>

<div class="mb-16 mt-8 flex flex-col items-center justify-center text-center">
	{#if content.title}
		<h3 class="mb-6 max-w-md text-4xl font-semibold">{content.title}</h3>
	{/if}
	{#if content.description}
		<p class="mb-8 max-w-2xl text-lg text-muted-foreground">{content.description}</p>
	{/if}
	{#if buttons.length > 0}
		<div class="flex flex-row gap-x-4">
			{#each buttons as button}
				<a href={button.url || '#'} target={button.newTab ? '_blank' : '_self'} rel={button.newTab ? 'noopener noreferrer' : ''}>
					<div
						class={cn(
							buttonVariants({
								size: 'sm',
								variant: button.type === 'secondary' ? 'outline' : 'default'
							}),
							''
						)}
					>
						<span>{button.text}</span>
					</div>
				</a>
			{/each}
		</div>
	{/if}
</div>